import { Genres } from 'enums';
import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

interface BoosterToolsGenreStore {
  activeSourcing: Genres | null;
  jobAds: Genres | null;
  socialSelling: Genres | null;
  marketingCampaign: Genres | null;

  setActiveSourcingGenre: (newGenre: Genres | null) => void;
  setJobAdsGenre: (newGenre: Genres | null) => void;
  setSocialSellingGenre: (newGenre: Genres | null) => void;
  setMarketingCampaignGenre: (newGenre: Genres | null) => void;

  resetAllGenres: () => void;
}

const useBoosterToolsGenreStore = createWithEqualityFn<BoosterToolsGenreStore>((set) => ({
  activeSourcing: Genres.ACTIVE_SOURCING,
  jobAds: Genres.JOB_OFFER,
  socialSelling: null,
  marketingCampaign: null,

  setActiveSourcingGenre(newGenre: Genres | null) {
    set({ activeSourcing: newGenre });
  },

  setJobAdsGenre(newGenre: Genres | null) {
    set({ jobAds: newGenre });
  },

  setSocialSellingGenre(newGenre: Genres | null) {
    set({ socialSelling: newGenre });
  },

  setMarketingCampaignGenre(newGenre: Genres | null) {
    set({ marketingCampaign: newGenre });
  },

  resetAllGenres() {
    set({ marketingCampaign: null, socialSelling: null });
  },
}), shallow);

export default useBoosterToolsGenreStore;
